<div class="mb-3 px-5 lg:px-0 max-w-md lg:max-w-full mx-auto">
  @if (orderPickupLocation$ | async; as location) {
    <div class="py-5 px-4.5 border-neutral-300 border text-neutral-800 rounded-md">
      <div class="flex items-center pb-5">
        <i class="icon icon-pin mr-3"></i>
        <span class="font-base font-bold lg:text-md">{{
          'basket.additonnal-informations.address-pickup-location' | translate
        }}</span>
      </div>
      <div class="font-base text-neutral-600 lg:text-md">
        @if (location.street_line1) {
          <span>{{ location.street_line1 }}</span>
        }
        @if (location.post_code) {
          <span>, {{ location.post_code }}</span>
        }
        @if (location.city) {
          <span>, {{ location.city }}</span>
        }
      </div>
    </div>
  }
</div>
